import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Button = styled.button`
width: auto;
height: auto;
color: ${(props) => props.color || "#000000"};
font-weight: bold;
font-size: 15px;
`
const ButtonOuter = styled.div`
display: flex;
align-items: center;
justify-content: center;
height: 51px;
padding-left:33px;
padding-right:33px;
border-radius: 50px;
border: ${(props) => props.border || "3px solid #0c0c0c"};
box-sizing: border-box;
cursor: pointer;
&:hover{ opacity: 0.7;};

${({ theme }) => theme.media.mobile`
margin-bottom: 25px;
    `}
`
class PlusButtonAtom extends PureComponent {
    render() {
        return (
          <ButtonOuter border={this.props.border}>
            <Button typo={this.props.typo} color={this.props.color}>
              더보기
            </Button>
          </ButtonOuter>
        );
    }
}

export default PlusButtonAtom;